import React, { useState } from "react"
import { currencyFormatWithSign } from "scripts/utils/currencyFormat"
import parseMarkdown from "scripts/utils/markdownParser"
import type { ProductServiceType } from "scripts/types"

type ProductServiceProps = {
  service: ProductServiceType
  onServiceChange?: (data: {
    code: string
    options: Array<{ code: string }>
  }) => Promise<void>
  lang: {
    services: Record<string, { name: string; uom: string; description: string }>
  }
  setIsLoadingCart: (loading: boolean) => void
}

// The component provides a way to select a service with options for the product
function ProductService({
  service = {
    code: "",
    options: [],
  },
  onServiceChange = async () => {},
  lang,
  setIsLoadingCart,
}: ProductServiceProps) {
  const checked = service.options.find((item) => item.selected)
  const [checkState, setCheckState] = useState(Boolean(checked))
  const [optionState, setOptionState] = useState(checked || service.options[0])

  const requestHandler = async (data: { optionState: any; checkState: boolean }) => {
    // Do api request. Only if checkState changed or (optionState changed and checkState is true)
    const newOptions = {
      code: service.code,
      checked: data.checkState,
      options: [
        {
          code: data.optionState.code,
        },
      ],
    }

    setIsLoadingCart(true)
    onServiceChange(newOptions)
  }

  const optionChangeHandler = (e) => {
    const newOptionsState = service.options.find((op) => op.code === e.target.value)
    setOptionState(newOptionsState)
    if (checkState) {
      requestHandler({ optionState: newOptionsState, checkState })
    }
  }

  const serviceChangeHandler = async (e) => {
    setCheckState(e.target.checked)
    requestHandler({ optionState, checkState: e.target.checked })
  }

  if (!service.code || service.options.length === 0) return null

  return (
    <div className="product-service-list">
      <label className="checkbox">
        <input
          type="checkbox"
          name={service.code}
          className="container-input"
          checked={checkState}
          onChange={serviceChangeHandler}
        />
        <span className="text">
          <div className="text__item">
            <div className="text-content">
              {lang.services[service.code].name}&nbsp;
              <div className="form-select form-select--small">
                <select
                  className="select__current"
                  value={optionState.code}
                  onChange={optionChangeHandler}
                >
                  {service.options.map((option) => (
                    <option key={option.code} value={option.code}>
                      {option.code} {lang.services[service.code].uom}
                    </option>
                  ))}
                </select>
              </div>
              <div className="info tooltip">
                <div className="info__tooltip tooltip__dropdown tooltip__outer">
                  <p
                    className="tooltip__text"
                    dangerouslySetInnerHTML={{
                      __html: parseMarkdown(
                        lang.services[service.code].description,
                      ),
                    }}
                  />
                </div>

                <span className="tooltip-opener">
                  <svg className="icon-exclamation">
                    <use xlinkHref="#exclamation" />
                  </svg>
                </span>
              </div>
              <span className="service__price">
                {currencyFormatWithSign(optionState.price)}
              </span>
            </div>
            {/* <div className="text-description">description</div> */}
          </div>
        </span>
        <span className="checkmark" />
      </label>
    </div>
  )
}

ProductService.propTypes = {}

export default ProductService
